export default "__VITE_ASSET__CM$gE7ZO__"